import API from '../utils/api';
import { getAuthHeaders } from '../context/auth/Auth';

export const getLevels = async (): Promise<any> => {
    return await API.get(
        '/levels',
        { headers: { ...getAuthHeaders() }}
    ).then((response) => response.data);
};